import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';

export const useScreenSizeBreakpoint = (breakpoint: Breakpoint) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
};
